import { Formik, FieldArray } from "formik";
import Loader from "../../loader";
import StepsDots from "../../form/StepsDots";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import PdfOrImageUploader from "../../pdfImage uploader";
import { profileStep3Schema } from "../../../utils/schema";
import { setRegisterStep } from "../../../redux/features/find-a-job/reducers/authReducer";
import {
  fetchfreelancerProfile,
  profileStep3Submit,
} from "../../../redux/features/find-a-job/actions/authAction";
import {
  getFreelancerFormData,
  getProfile,
  setProfile,
  updateFreelancerFormData,
} from "../../../utils/pip";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const ProfileSetupStep3 = () => {
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const [savedData, setSavedData] = useState({});
  const [originalExperiences, setOriginalExperiences] = useState([]);
  const [deleteExperienceIds, setDeleteExperienceIds] = useState([]);
  const [deleteProjectIds, setDeleteProjectIds] = useState([]);
  const [deleteCertificateIds, setDeleteCertificateIds] = useState([]);

  console.log({ deleteProjectIds })

  const splitList = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (!value) return [];
    return String(value)
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const parseArray = (value, fallback = []) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return fallback;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch {
        return trimmed
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
    }
    return fallback;
  };

  const normalizeCvFiles = (value) => {
    const items = parseArray(value, []);
    return items.filter(Boolean);
  };

  const normalizeCertificateFiles = (value) => {
    const items = parseArray(value, []);
    return items.filter(Boolean);
  };

  const normalizeDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toISOString().slice(0, 10);
  };

  const getExperienceImageValue = (exp) =>
    exp?.experience_images || exp?.image || exp?.experience_image || "";

  const normalizeExperienceForCompare = (exp) => ({
    experience_id: exp?.experience_id || exp?.id || exp?.experienceId || null,
    job_title: String(exp?.job_title || "").trim(),
    company_name: String(exp?.company_name || "").trim(),
    location: String(exp?.location || "").trim(),
    start_date: normalizeDate(exp?.start_date),
    end_date: normalizeDate(exp?.end_date),
    currently_working: !!exp?.currently_working,
    job_description: String(exp?.job_description || "").trim(),
    link: String(exp?.link || "").trim(),
    image: String(getExperienceImageValue(exp) || ""),
  });

  const isFileLike = (value) => value instanceof File || value instanceof Blob;

  const resolveWorkSamplePreview = (file) => {
    if (!file) return "";
    if (typeof file === "string") return file;
    if (file.preview) return file.preview;
    if (file.project_url) return file.project_url;
    if (file.url) return file.url;
    if (file.file) {
      if (typeof file.file === "string") return file.file;
      if (file.file?.preview) return file.file.preview;
      if (isFileLike(file.file)) return URL.createObjectURL(file.file);
    }
    if (isFileLike(file)) return URL.createObjectURL(file);
    return "";
  };

  const resolveWorkSampleName = (file, idx) => {
    if (!file) return `work-sample-${idx}`;
    if (typeof file === "string") return file.split("/").pop() || `work-sample-${idx}`;
    if (file.name) return file.name;
    if (file.project_url)
      return file.project_url.split("/").pop() || `work-sample-${idx}`;
    if (file.url) return file.url.split("/").pop() || `work-sample-${idx}`;
    return `work-sample-${idx}`;
  };

  const resolveWorkSampleType = (file, preview) => {
    if (!file) return "image";
    if (typeof file === "string") {
      const lower = file.toLowerCase();
      if (lower.includes(".zip")) return "zip";
      return lower.includes(".pdf") ? "pdf" : "image";
    }
    if (file.type?.includes("zip")) return "zip";
    if (file.type?.includes("pdf")) return "pdf";
    if (file.project_url) {
      const lower = file.project_url.toLowerCase();
      if (lower.includes(".zip")) return "zip";
      return lower.includes(".pdf") ? "pdf" : "image";
    }
    if (file.url) {
      const lower = file.url.toLowerCase();
      if (lower.includes(".zip")) return "zip";
      return lower.includes(".pdf") ? "pdf" : "image";
    }
    if (preview) {
      const lower = preview.toLowerCase();
      if (lower.includes(".zip")) return "zip";
      return lower.includes(".pdf") ? "pdf" : "image";
    }
    return "image";
  };

  const emptyExperience = {
    job_title: "",
    company_name: "",
    job_description: "",
    location: "",
    experience_images: "",
    start_date: "",
    end_date: "",
    currently_working: false,
    link: "",
  };

  const resolveExperienceImage = (value) => {
    if (!value) return { file: null, value: "" };
    const item = Array.isArray(value) ? value[0] : value;
    if (!item) return { file: null, value: "" };
    if (item instanceof File) return { file: item, value: "" };
    if (item?.file instanceof File) return { file: item.file, value: "" };
    if (typeof item === "string") return { file: null, value: item };
    if (typeof item?.url === "string") return { file: null, value: item.url };
    if (typeof item?.preview === "string")
      return { file: null, value: item.preview };
    if (typeof item?.file === "string")
      return { file: null, value: item.file };
    return { file: null, value: "" };
  };

  const handleStep3 = (values) => {
    updateFreelancerFormData("profileStep3", {
      ...values,
      cv: values.cv || [],
      work_samples: (values.work_samples || []).map((f) =>
        f instanceof File
          ? { name: f.name, type: f.type, preview: URL.createObjectURL(f) }
          : f
      ),
      delete_project_ids: deleteProjectIds,
      certificates: values.certificates || [],
      delete_certificate_ids: deleteCertificateIds,
      delete_experience_ids: deleteExperienceIds,
    });

    const formData = new FormData();
    const portfolioLinks = values?.portfolio_links || [];
    const samplePortfolioLink = portfolioLinks.find((link) => link)?.trim() || "";
    formData.append("sample_portfolio_link", samplePortfolioLink);
    const originalById = new Map(
      originalExperiences
        .map((exp) => normalizeExperienceForCompare(exp))
        .filter((exp) => exp.experience_id)
        .map((exp) => [String(exp.experience_id), exp])
    );

    const updatedExperiences = [];
    const updatedExperienceIds = [];
    const updatedImageFiles = [];
    const experienceImageFiles = [];

    const shouldMarkUpdated = (original, current) =>
      original.job_title !== current.job_title ||
      original.company_name !== current.company_name ||
      original.location !== current.location ||
      original.start_date !== current.start_date ||
      original.end_date !== current.end_date ||
      original.currently_working !== current.currently_working ||
      original.job_description !== current.job_description ||
      original.link !== current.link ||
      original.image !== current.image;

    const sanitizedExperiences = (values?.experiences || [])
      .map((exp) => {
        const endDate =
          exp.currently_working || !exp.end_date ? null : exp.end_date;
        const resolvedImage = resolveExperienceImage(exp.experience_images);
        const expId = exp?.experience_id || exp?.id || exp?.experienceId || null;
        if (expId) {
          const normalizedCurrent = normalizeExperienceForCompare({
            ...exp,
            end_date: endDate,
            experience_images: resolvedImage.value || exp.experience_images,
          });
          const original = originalById.get(String(expId));
          const isImageUpdated = !!resolvedImage.file;
          const hasChanges = original
            ? shouldMarkUpdated(original, normalizedCurrent)
            : true;
          if (hasChanges || isImageUpdated) {
            updatedExperienceIds.push(expId);
            updatedExperiences.push({
              experience_id: expId,
              is_image_updated: isImageUpdated,
              job_title: normalizedCurrent.job_title || "",
              company_name: normalizedCurrent.company_name || "",
              location: normalizedCurrent.location || "",
              start_date: normalizedCurrent.start_date || null,
              end_date: endDate,
              currently_working: normalizedCurrent.currently_working || false,
              job_description: normalizedCurrent.job_description || "",
              link: normalizedCurrent.link || "",
            });
            if (isImageUpdated) {
              updatedImageFiles.push(resolvedImage.file);
            }
          }
          return null;
        }
        if (resolvedImage.file) {
          experienceImageFiles.push(resolvedImage.file);
        }
        return {
          ...exp,
          location: exp.location || "",
          experience_images: resolvedImage.value || "",
          end_date: endDate,
        };
      })
      .filter(Boolean);
    formData.append("experiences", JSON.stringify(sanitizedExperiences));

    (values?.work_samples || []).forEach((file) => {
      if (file instanceof File) {
        formData.append("projects", file);
      }
    });
    (values?.cv || []).forEach((file) => {
      if (file instanceof File) {
        formData.append("cv", file);
      }
    });
    (values?.certificates || []).forEach((file) => {
      if (file instanceof File) {
        formData.append("certificates", file);
      }
    });
    experienceImageFiles.forEach((file) => {
      formData.append("experience_images", file);
    });
    if (updatedExperienceIds.length) {
      formData.append(
        "updated_experience_ids",
        Array.from(new Set(updatedExperienceIds)).join(",")
      );
    }
    if (updatedExperiences.length) {
      formData.append("updated_experience", JSON.stringify(updatedExperiences));
    }
    updatedImageFiles.forEach((file) => {
      formData.append("updated_images", file);
    });
    const uniqueDeleteExperienceIds = Array.from(
      new Set((deleteExperienceIds || []).filter(Boolean))
    );
    if (uniqueDeleteExperienceIds.length) {
      formData.append(
        "delete_experience_ids",
        uniqueDeleteExperienceIds.join(",")
      );
    }
    const uniqueDeleteIds = Array.from(
      new Set((deleteProjectIds || []).filter(Boolean))
    );
    if (uniqueDeleteIds.length) {
      formData.append("delete_project_ids", uniqueDeleteIds.join(","));
    }
    const uniqueDeleteCertificateIds = Array.from(
      new Set((deleteCertificateIds || []).filter(Boolean))
    );
    if (uniqueDeleteCertificateIds.length) {
      formData.append(
        "delete_certificate_ids",
        uniqueDeleteCertificateIds.join(",")
      );
    }

    const callback = (response, error) => {
      if (!response?.success) {
        const message =
          response?.message ||
          error?.data?.message ||
          error?.message ||
          "Something went wrong. Please try again.";
        toast.error(message);
        return;
      }
      dispatch(setRegisterStep("profileStep4"));
    };

    dispatch(profileStep3Submit({ payload: formData, callback }));
  };

  const refreshStep2FromProfile = async () => {
    const res = await dispatch(fetchfreelancerProfile());
    const data = res?.payload?.data;
    if (!data) return;
    const existing = getProfile("freelancer") || {};
    const merged = {
      ...existing,
      ...data,
      full_name:
        data.full_name ||
        existing.full_name ||
        `${data.first_name || ""} ${data.last_name || ""}`.trim(),
      first_name: data.first_name || existing.first_name || data.full_name || "",
      last_name: data.last_name || existing.last_name || "",
    };
    setProfile("freelancer", merged);
    const openTalent = merged.open_talent || {};
    updateFreelancerFormData("profileStep2", {
      primary_role: openTalent.primary_role || "",
      years_of_experience: openTalent.years_of_experience || "",
      key_skills: splitList(openTalent.key_skills || openTalent.skills),
      tools: splitList(openTalent.tools || openTalent.tools_software_used),
      availability: splitList(openTalent.availability),
      hourly_rate: openTalent.hourly_rate || "",
      preferred_project_type: splitList(openTalent.preferred_project_type),
    });
  };

  useEffect(() => {
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data || {};
      const openTalent = data?.open_talent || {};
      const normalizedExperiences = (data?.experiences || []).map((exp) => ({
        ...exp,
        location: exp?.location || "",
        experience_images:
          exp?.experience_images || exp?.image || exp?.experience_image || "",
        start_date: normalizeDate(exp.start_date),
        end_date: normalizeDate(exp.end_date),
      }));
      const localStep3 = getFreelancerFormData()?.profileStep3 || {};
      setSavedData({
        experiences: normalizedExperiences,
        portfolio_links:
          openTalent?.sample_portfolio_link
            ? [openTalent.sample_portfolio_link]
            : [""],
        cv: normalizeCvFiles(openTalent?.cv || data?.cv),
        certificates: normalizeCertificateFiles(
          openTalent?.certificates || data?.certificates
        ),
        work_samples: parseArray(openTalent?.projects, []),
      });
      setOriginalExperiences(normalizedExperiences);
      setDeleteExperienceIds([]);
      setDeleteProjectIds([]);
      setDeleteCertificateIds([]);
    });
  }, [dispatch]);

  const handlePrevious = async () => {
    await refreshStep2FromProfile();
    dispatch(setRegisterStep("profileStep2"));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_4_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    Experience & Work Samples
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Add your experience and share your best work to stand out.
                  </p>
                </div>
                <Formik
                  initialValues={{
                    experiences:
                      savedData.experiences && savedData.experiences.length
                        ? savedData.experiences
                        : [emptyExperience],
                    portfolio_links:
                      savedData.portfolio_links && savedData.portfolio_links.length
                        ? savedData.portfolio_links
                        : [""],
                    cv: savedData.cv || [],
                    certificates: savedData.certificates || [],
                    work_samples: savedData.work_samples || [],
                  }}
                  validationSchema={profileStep3Schema}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    handleStep3(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <div className="col-md-12">
                          <h6 className="ct_fs_16 ct_darkblue_text mb-3">
                            Experience
                          </h6>
                          <FieldArray
                            name="experiences"
                            render={(arrayHelpers) => (
                              <div className="d-flex flex-column gap-4">
                                {values.experiences?.map((exp, idx) => (
                                  <div
                                    key={`experience-${idx}`}
                                    className="ct_outline_bg ct_border_radius_10 ct_p_20"
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                      <p className="mb-0 ct_fs_14 ct_darkblue_text">
                                        Experience {idx + 1}
                                      </p>
                                      {values.experiences.length > 1 && (
                                        <button
                                          type="button"
                                          className="ct_yellow_btn ct_outline_grey py-1 px-3 ct_white_nowrap"
                                          style={{ minWidth: "90px" }}
                                          onClick={() => {
                                            const expId =
                                              exp?.experience_id ||
                                              exp?.id ||
                                              exp?.experienceId;
                                            if (expId) {
                                              setDeleteExperienceIds((prev) => [
                                                ...(prev || []),
                                                expId,
                                              ]);
                                            }
                                            arrayHelpers.remove(idx);
                                          }}
                                        >
                                          Remove
                                        </button>
                                      )}
                                    </div>
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Job Title
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="Job Title"
                                            name={`experiences.${idx}.job_title`}
                                            value={exp.job_title}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.job_title`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Company Name
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="Company Name"
                                            name={`experiences.${idx}.company_name`}
                                            value={exp.company_name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.company_name`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Location
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="Location"
                                            name={`experiences.${idx}.location`}
                                            value={exp.location}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.location`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Company Image
                                          </label>
                                          <PdfOrImageUploader
                                            maxFiles={1}
                                            multiple={false}
                                            acceptType="image/*"
                                            placeholder="Upload Company Image"
                                            replaceOnSelect={true}
                                            existingFiles={
                                              exp?.experience_images
                                                ? [
                                                  (() => {
                                                    const rawValue =
                                                      exp.experience_images ||
                                                      exp.image ||
                                                      exp.experience_image ||
                                                      "";
                                                    const raw = Array.isArray(rawValue)
                                                      ? rawValue[0]
                                                      : rawValue;
                                                    if (!raw) return null;
                                                    if (raw instanceof File) {
                                                      return {
                                                        id: raw.name || idx,
                                                        file: raw,
                                                        name:
                                                          raw.name || `experience-${idx + 1}`,
                                                        type: raw.type || "image",
                                                        preview: URL.createObjectURL(raw),
                                                        isExisting: false,
                                                      };
                                                    }
                                                    if (raw?.file instanceof File) {
                                                      return {
                                                        id: raw.id || idx,
                                                        file: raw.file,
                                                        name:
                                                          raw.name ||
                                                          raw.file.name ||
                                                          `experience-${idx + 1}`,
                                                        type: raw.type || raw.file.type || "image",
                                                        preview:
                                                          raw.preview ||
                                                          URL.createObjectURL(raw.file),
                                                        isExisting: false,
                                                      };
                                                    }
                                                    const url =
                                                      (typeof raw === "string" && raw) ||
                                                      raw?.url ||
                                                      raw?.preview ||
                                                      (typeof raw?.file === "string" ? raw.file : "");
                                                    if (!url) return null;
                                                    return {
                                                      id: raw?.id || idx,
                                                      file: url,
                                                      name:
                                                        raw?.name ||
                                                        (typeof url === "string"
                                                          ? url.split("/").pop()
                                                          : `experience-${idx + 1}`),
                                                      type: raw?.type || "image",
                                                      preview: url,
                                                      isExisting: true,
                                                    };
                                                  })(),
                                                ].filter(Boolean)
                                                : []
                                            }
                                            onChange={(newFiles) => {
                                              setTouched({
                                                ...touched,
                                                experiences: true,
                                              });
                                              setFieldValue(
                                                `experiences.${idx}.experience_images`,
                                                newFiles?.[0] || ""
                                              );
                                            }}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.experience_images`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Start Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control ct_input"
                                            name={`experiences.${idx}.start_date`}
                                            max={new Date().toISOString().split("T")[0]}
                                            value={exp.start_date}
                                            onChange={(e) => {
                                              const nextStartDate = e.target.value;
                                              setFieldValue(
                                                `experiences.${idx}.start_date`,
                                                nextStartDate
                                              );
                                              if (
                                                exp.end_date &&
                                                nextStartDate &&
                                                exp.end_date < nextStartDate
                                              ) {
                                                setFieldValue(
                                                  `experiences.${idx}.end_date`,
                                                  nextStartDate
                                                );
                                              }
                                            }}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.start_date`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            End Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control ct_input"
                                            name={`experiences.${idx}.end_date`}
                                            max={new Date().toISOString().split("T")[0]}
                                            min={exp.start_date || ""}
                                            value={exp.end_date}
                                            onChange={(e) => {
                                              const nextEndDate = e.target.value;
                                              if (
                                                exp.start_date &&
                                                nextEndDate &&
                                                nextEndDate < exp.start_date
                                              ) {
                                                setFieldValue(
                                                  `experiences.${idx}.end_date`,
                                                  exp.start_date
                                                );
                                              } else {
                                                setFieldValue(
                                                  `experiences.${idx}.end_date`,
                                                  nextEndDate
                                                );
                                              }
                                            }}
                                            onBlur={handleBlur}
                                            disabled={exp.currently_working}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.end_date`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-3">
                                          <div className="d-flex align-items-center gap-2">
                                            <input
                                              type="checkbox"
                                              id={`experience_current_${idx}`}
                                              name={`experiences.${idx}.currently_working`}
                                              checked={exp.currently_working}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  `experiences.${idx}.currently_working`,
                                                  e.target.checked
                                                );
                                                if (e.target.checked) {
                                                  setFieldValue(
                                                    `experiences.${idx}.end_date`,
                                                    ""
                                                  );
                                                }
                                              }}
                                            />
                                            <label
                                              htmlFor={`experience_current_${idx}`}
                                              className="ct_fs_14 ct_darkblue_text mb-0"
                                            >
                                              Currently working here
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Work Experience
                                          </label>
                                          <textarea
                                            className="form-control ct_input h-auto"
                                            rows={4}
                                            placeholder="Work Experience"
                                            name={`experiences.${idx}.job_description`}
                                            value={exp.job_description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.job_description`}
                                          />
                                        </div>
                                      </div>
                                      {/* <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Link (Optional)
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="https://"
                                            name={`experiences.${idx}.link`}
                                            value={exp.link}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.link`}
                                          />
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="ct_yellow_btn ct_outline_grey py-2"
                                  onClick={() => arrayHelpers.push(emptyExperience)}
                                >
                                  Add Experience
                                </button>
                              </div>
                            )}
                          />
                        </div>
                        <div className="form-group mt-4">
                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                            Upload CV (PDF only)
                          </label>
                          <PdfOrImageUploader
                            maxFiles={1}
                            multiple={false}
                            acceptType="application/pdf,.pdf"
                            placeholder="Upload CV (PDF only)"
                            replaceOnSelect={true}
                            existingFiles={
                              values?.cv && Array.isArray(values.cv)
                                ? values.cv.map((file, idx) => ({
                                  id: file?.id || idx,
                                  file: file,
                                  name:
                                    file?.name ||
                                    (typeof file === "string"
                                      ? file.split("/").pop()
                                      : `cv-${idx + 1}.pdf`),
                                  type: "pdf",
                                  preview:
                                    typeof file === "string"
                                      ? file
                                      : file?.preview || file?.url || "",
                                  isExisting: !(file instanceof File),
                                }))
                                : []
                            }
                            onChange={(newFiles) => {
                              setTouched({ cv: true });
                              setFieldValue("cv", newFiles);
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="cv"
                          />
                        </div>
                        <div className="form-group mt-4">
                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                            Upload Certificates (PDF or Image)
                          </label>
                          <PdfOrImageUploader
                            maxFiles={5}
                            multiple={true}
                            acceptType="application/pdf,image/*"
                            placeholder="Upload Certificates (PDF or Image)"
                            existingFiles={
                              values?.certificates && Array.isArray(values.certificates)
                                ? values.certificates.map((file, idx) => ({
                                  id: file?.id || file?.certificate_id,
                                  file: file,
                                  name:
                                    file?.name ||
                                    (typeof file === "string"
                                      ? file.split("/").pop()
                                      : `certificate-${idx + 1}`),
                                  type:
                                    typeof file === "string"
                                      ? file.toLowerCase().includes(".pdf")
                                        ? "pdf"
                                        : "image"
                                      : file?.type
                                        ? file.type
                                        : (file?.url || file?.preview || file?.file || "")
                                          .toLowerCase()
                                          .includes(".pdf")
                                          ? "pdf"
                                          : "image",
                                  preview:
                                    typeof file === "string"
                                      ? file
                                      : file?.preview || file?.url || file?.file || "",
                                  isExisting: !(file instanceof File),
                                }))
                                : []
                            }
                            onChange={(newFiles, removedIds = []) => {
                              setTouched({ certificates: true });
                              setFieldValue("certificates", newFiles);
                              setDeleteCertificateIds(removedIds);
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="certificates"
                          />
                        </div>
                        <div className="col-md-12 ct_mt_30">
                          <h6 className="ct_fs_16 ct_darkblue_text mb-3">
                            Work Samples
                          </h6>
                          <div className="form-group mb-4">
                            <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Portfolio Links / Case Studies
                            </label>
                            <FieldArray
                              name="portfolio_links"
                              render={(arrayHelpers) => (
                                <div className="d-flex flex-column gap-2">
                                  {values.portfolio_links?.map((link, idx) => (
                                    <div key={`portfolio-link-${idx}`} className="d-flex align-items-center gap-2">
                                      <input
                                        type="text"
                                        className="form-control ct_input"
                                        placeholder="https://"
                                        name={`portfolio_links.${idx}`}
                                        value={link}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      {values.portfolio_links.length > 1 && (
                                        <button
                                          type="button"
                                          className="ct_yellow_btn ct_outline_grey py-1 px-3 ct_white_nowrap"
                                          style={{ minWidth: "90px" }}
                                          onClick={() => arrayHelpers.remove(idx)}
                                        >
                                          Remove
                                        </button>
                                      )}
                                      <ErrorMessage
                                        errors={errors}
                                        touched={touched}
                                        fieldName={`portfolio_links.${idx}`}
                                      />
                                    </div>
                                  ))}
                                  <button
                                    type="button"
                                    className="ct_yellow_btn ct_outline_grey py-2"
                                    onClick={() => arrayHelpers.push("")}
                                  >
                                    Add Link
                                  </button>
                                </div>
                              )}
                            />
                          </div>
                          <div className="form-group mb-4">
                            <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Upload Work Samples (Optional)
                            </label>
                            <PdfOrImageUploader
                              maxFiles={10}
                              multiple={true}
                              acceptType=".zip,application/zip"
                              placeholder="Upload Work Samples (ZIP only)"
                              replaceOnSelect={false}
                              existingFiles={
                                values?.work_samples && Array.isArray(values.work_samples)
                                  ? values.work_samples.map((file, idx) => {
                                    const isFile = isFileLike(file);
                                    const preview = resolveWorkSamplePreview(file);
                                    const rawFile = isFile ? file : preview;
                                    const fileId =
                                      file?.open_talent_project_id ||
                                      file?.project_id ||
                                      file?.id ||
                                      undefined;
                                    return {
                                      id: fileId,
                                      file: rawFile,
                                      name: resolveWorkSampleName(file, idx),
                                      type: resolveWorkSampleType(file, preview),
                                      preview: isFile ? preview : file?.preview || null,
                                      isExisting: !isFile,
                                    };
                                  })
                                  : []
                              }
                              onChange={(newFiles, removedIds = []) => {
                                console.log({ removedIds })
                                setTouched({ work_samples: true });
                                setFieldValue("work_samples", newFiles);
                                setDeleteProjectIds(removedIds);
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="work_samples"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="d-flex gap-2 mt-2">
                        <button
                          type="button"
                          class="ct_outline_btn w-100 mx-auto"
                          onClick={handlePrevious}
                        >
                          Previous
                        </button>
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={3} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep3;
